import React from 'react';
import { useShallow } from 'zustand/react/shallow';

import { usePrintsUiStore, usePrintsOrderStore } from '../stores';
import { VIEW_MODE } from '../constants';

export default function DebugControls() {
  // --- ACTIONS ---
  const { toggleDebugView, toggleAutoSave } = usePrintsUiStore(
    useShallow((state) => ({
      toggleDebugView: state.toggleDebugView,
      toggleAutoSave: state.toggleAutoSave,
    })),
  );
  const saveOrder = usePrintsOrderStore((state) => state.saveOrder);

  // --- STATE ---
  const currentView = usePrintsUiStore((state) => state.currentView);
  const isSaving = usePrintsUiStore((state) => state.isSaving);
  const autoSaveEnabled = usePrintsUiStore((state) => state.autoSaveEnabled);

  return (
    <div className="d-flex align-items-center justify-content-md-end my-3 mr-1">
      {isSaving && <div className="mr-1">💾 Saving…</div>}
      <div className="form-check mr-1">
        <input
          className="form-check-input"
          type="checkbox"
          checked={autoSaveEnabled}
          onChange={toggleAutoSave}
          id="autoSaveCheck"
          disabled={isSaving}
        />
        <label className="form-check-label" htmlFor="autoSaveCheck">
          Auto-save
        </label>
      </div>

      <button
        className="btn btn-sm btn-outline-secondary"
        onClick={toggleDebugView}>
        {currentView === VIEW_MODE.DEBUG ? 'Photo View' : 'Debug View'}
      </button>
      <button
        className="btn btn-sm btn-primary ml-2"
        onClick={saveOrder}
        disabled={isSaving}>
        Save Order
      </button>
    </div>
  );
}
